import React from 'react';

/**
 * Returns the currency symbol
 * @returns {string}
 */
export const getCurrencySymbol = (): string => {
  return '\u0024';
};

/**
 * Conditionally/ per countryBuild renders currency symbol
 * @returns {JSX.Element}
 */
function CurrencySymbol(): JSX.Element {
  const currency = getCurrencySymbol();
  return <>{currency}</>;
}

export default CurrencySymbol;
